import {
  Address,
  Airport,
  AuthenticatedUser,
  ConnectingAirport,
  ContactInformation,
  CoreTransferInformation,
  LuggageRequirements,
  OversizeLuggageRequirements,
  PassengerRequirements,
} from '../types'
import useAxios from './useAxios'

type Transfer = CoreTransferInformation &
  Airport &
  ConnectingAirport &
  Address &
  PassengerRequirements &
  LuggageRequirements &
  OversizeLuggageRequirements

export interface OrderStoreRequest {
  customer_first_name: string
  customer_last_name: string
  customer_phone: string
  customer_email: string

  transfers: Transfer[]
}

export interface OrderStoreResponse {
  order_id: number
  payment_client_secret: string
  payment_status: string
}

export interface OrderShowResponse {
  transfers: Required<Transfer & ContactInformation>[]
}

const useOrders = () => {
  const instance = useAxios()

  const store = async (user: AuthenticatedUser, transfers: Transfer[]) => {
    const request: OrderStoreRequest = {
      customer_first_name: user.first_name || '',
      customer_last_name: user.last_name || '',
      customer_phone: user.phone_number || '',
      customer_email: user.email,

      transfers,
    }

    return await instance.post<OrderStoreResponse>('ac/v1/orders', request)
  }

  const find = async (id: number | string) => {
    return await instance.get<OrderShowResponse>(`ac/v1/orders/${id}`)
  }

  return {
    store,
    find,
  }
}

export default useOrders
